import { toast } from 'react-toastify';
import { useState } from 'react';

const handle_toast = (obj) => {

    // const statusCode = obj.statusCode ? obj.statusCode : null;
    const message = obj.message ? obj.message : null;
    const details = obj.details ? fetchDetails(obj.details) : null;
    
    if(obj.status == 'error'){
        if(details) toast.error(<CustomToast message={message} details={details}/>, {autoClose: false, position: 'bottom-right', closeOnClick: false })
        if(details == null) toast.error(obj.message, { autoClose: 5000, position: 'bottom-right' })
    }
    if(obj.status == 'success'){
        if(details) toast.success(<CustomToast message={message} details={details}/>, {autoClose: 5000, position: 'bottom-right', closeOnClick: false })
        if(details == null) toast.success(obj.message, { autoClose: 5000, position: 'bottom-right' })
    }
}


const fetchDetails = (data) => {
    const detailsObj = []
    if(typeof data == 'string') {
        detailsObj.push(data)
    } 
    else if(Array.isArray(data)){
        data.forEach((obj) => {
            detailsObj.push(obj.message)
        })
    }
    return detailsObj;
}

const CustomToast = ({message, details}) => {
    const [isExpanded, setExpanded]= useState(false);

    return(
        <div>
            <p>{message} &nbsp;
                {details && 
                <se-icon size='nano' option='button' onClick={() => setExpanded((prev) => !prev)}>
                    {!isExpanded ? 'arrow2_down': 'arrow2_up'}
                </se-icon>
                }
                {isExpanded && <pre style={{marginTop: '10px', whiteSpace: 'pre-wrap'}}>{details}</pre>}
            </p>
        </div>
    )
}

export default handle_toast